import { CASESOFTWARE_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: CASESOFTWARE_MNG,
  params: null,
  view: {
    title: '创建用例',
    labelPosition: 'right',
    labelWidth: '170px',
    width: '700px',
    content: [
      {
        $id: 'testCaseName',
        $type: 'input',
        label: 'testcaseMng.testCaseName',
        $el: {
          placeholder: '请输入用例名称',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: 'testcaseMng.testCaseName'
          }
        ]
      },
      {
        $id: 'relevant',
        $type: 'radio-group',
        label: '适用范围',
        $options: [
          {
            label: '通用',
            value: 'COMMON'
          },
          {
            label: '专属',
            value: 'SPEC'
          }
        ],
        rules: [
          {
            notEmpty: '适用范围'
          }
        ]
      },
      {
        $id: 'testCaseContent',
        $type: 'input',
        $el: {
          placeholder: '请输入用例内容',
          type: 'textarea',
          rows: 5
        },
        label: 'testcaseMng.testCaseContent',
        rules: [
          {
            notEmpty: 'testcaseMng.testCaseContent'
          }
        ]
      },
      {
        $id: 'testCaseScene',
        $type: 'input',
        label: 'testcaseMng.testCaseScene',
        $el: {
          placeholder: '请输入用例场景',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        },
        rules: [
          {
            notEmpty: 'testcaseMng.testCaseScene'
          }
        ]
      },
      {
        $id: 'userDemand',
        $type: 'input',
        label: 'testcaseMng.testUserDemand',
        $el: {
          placeholder: '请输入用户诉求',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        },
        rules: [
          {
            notEmpty: 'testcaseMng.testUserDemand'
          }
        ]
      },
      {
        $id: 'testCaseStep',
        $type: 'input',
        label: 'testcaseMng.testCaseStep',
        $el: {
          placeholder: '请输入用户步骤',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        },
        rules: [
          {
            notEmpty: 'testcaseMng.testCaseStep'
          }
        ]
      },
      {
        $id: 'testCaseExpectedResult',
        $type: 'input',
        label: 'testcaseMng.testCaseExpectedResult',
        $el: {
          placeholder: '请输入预期结果',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        },
        rules: [
          {
            notEmpty: 'testcaseMng.testCaseExpectedResult'
          }
        ]
      },
      {
        $id: 'compatibleDTOList',
        $type: 'sky-product-os-relate',
        label: '支持的产品及操作系统',
        rules: [
          {
            // notEmpty: '支持的产品及操作系统'
          }
        ]
      }
    ]
  }
}
